
// import './App.css';
import { useEffect, useState } from 'react';
import { getQuestion, updateQuestion, createQuestion } from './../services/api';
import AnswersTable from '../components/answersTable';
import { useParams } from 'react-router-dom'
import {
    makeStyles, FormControl, InputLabel, Select, MenuItem, TextField, Button
} from '@material-ui/core';

const classes = {};

function Question() {
    let { assessmentSectionId, questionId } = useParams();
    const [question, setQuestion] = useState(null)
    const [loading, setLoading] = useState(true);
    const [text, setText] = useState("");
    const [target, setTarget] = useState("");
    const [order, setOrder] = useState("");

    useEffect(() => {
        if (questionId) {
            getQuestion(questionId).then((res) => {
                setQuestion(res);
                setLoading(false);
                setText(res.questionTRs[0].text);
                setTarget(res.target);
                setOrder(res.order);
            });
        } else {

        }
    }, []);

    const handleFieldChange = (setFunction) => {
        return (event) => {
            setFunction(event.target.value);
        }
    };

    const saveChanges = () => {
        question.questionTRs[0].text = text;
        question.target = target;
        question.order = order;
        if(question.id) {
            updateQuestion(question);
        } else {
            question.assessment_section_id = assessmentSectionId;
            createQuestion(question);
        }
    }

    function renderQuestionForm() {
        return <div>
            <div className={classes.container}>
                <FormControl className={classes.formControl}>
                    <TextField
                        label="text"
                        value={text}
                        onChange={handleFieldChange(setText)}
                        className={classes.formTextField}
                    />
                    <TextField
                        label="target"
                        value={target}
                        onChange={handleFieldChange(setTarget)}
                        className={classes.formTextField}
                    />
                    <TextField
                        label="order"
                        value={order}
                        onChange={handleFieldChange(setOrder)}
                        className={classes.formTextField}
                    />
                </FormControl>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={saveChanges}
                >
                    Save
                </Button>
            </div>
        </div>
    }

    return (
        <div>
            <header className="App-header">
                Question
            </header>
            <AnswersTable answers={[]}></AnswersTable>
        </div>
    );
}

export default Question;
